import { validates } from '../utils/ValidateFormObject'

const podcast = {
  tipo: {
    required: true
  },
  titulo: {
    required: true
  },
  autores: {
    required: true
  },
  especialidades: {
    required: true
  },
  pesoDA: {
    required: true
  },
  idioma: {
    required: true
  },
  palavrasChave: {
    required: true
  },
  codigo: {
    required: true
  },
  tituloCurso: {
    required: false
  },
  autoresCurso: {
    required: false
  },
  copyrightCurso: {
    required: false,
    func: validates.copyright,
    errorMessage: 'Este campo deve conter 4 dígitos numéricos.'
  },
  edicaoCurso: {
    required: false
  },
  codigoProtheus: {
    required: false,
    func: validates.isbn,
    errorMessage: 'Este campo deve conter um número de ISBN válido.'
  },
  especialidadesCurso: {
    required: false
  },
  tituloModulo: {
    required: true
  },
  autoresModulo: {
    required: true
  },
  descricao: {
    required: false
  },
  copyrightModulo: {
    required: true
  },
  especialidadesModulo: {
    required: true
  },
  cursoReferencia: {
    required: false
  }
}

export default podcast



// WEBPACK FOOTER //
// ./src/contentSchema/podcast.js